import script from "./WalletDeposit.vue?vue&type=script&setup=true&lang=js"
export * from "./WalletDeposit.vue?vue&type=script&setup=true&lang=js"

import "./WalletDeposit.vue?vue&type=style&index=0&id=2b60298c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b60298c"]])

export default __exports__